var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tiny"},[_c('tiny',{attrs:{"value":_vm.value,"init":_vm.tinyInit},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }